// IMPORTANT: Change this to your backend server's IP address
// IMPORTANT: Use your backend domain (no port)
const SERVER_DOMAIN = "api.pushpacabs.com"; // Your backend domain

const config = {
  // API Configuration
  API_BASE_URL: `https://${SERVER_DOMAIN}/api/v1`,

  // Socket.io Configuration
  SOCKET_URL: `https://${SERVER_DOMAIN}`,

  // API Endpoints
  endpoints: {
    // Auth
    LOGIN: '/admin/login',
    LOGOUT: '/admin/logout',

    // Dashboard
    DASHBOARD_STATS: '/admin/dashboard/stats',

    // Rides  
    RIDES_LIST: '/admin/rides',
    RIDE_DETAILS: '/admin/rides/:id',

    // Drivers
    DRIVERS_LIST: '/admin/drivers',
    DRIVER_DETAILS: '/admin/drivers/:id',
    DRIVER_ADD: '/admin/drivers',
    DRIVER_UPDATE: '/admin/drivers/:id',
    DRIVER_VERIFY: '/admin/drivers/:id/verify-document',
    DRIVER_VERIFY_STATUS: '/admin/drivers/:id/verify',
    DRIVER_BLOCK: '/admin/drivers/:id/block',
    DRIVER_DELETE: '/admin/drivers/:id',
    DRIVER_UPLOAD_DOCUMENT: '/admin/drivers/:id/upload-document',
    DRIVER_DELETE_DOCUMENT: '/admin/drivers/:id/documents/:documentId',

    // Passengers
    PASSENGERS_LIST: '/admin/passengers',
    PASSENGER_DETAILS: '/admin/passengers/:id',
    PASSENGER_ADD: '/admin/passengers',
    PASSENGER_UPDATE: '/admin/passengers/:id',
    PASSENGER_DELETE: '/admin/passengers/:id',

    // Verifications
    PENDING_VERIFICATIONS: '/admin/drivers/pending-verification',

    // Payments
    TRANSACTIONS_LIST: '/admin/transactions',
    TRANSACTION_DETAILS: '/admin/transactions/:id',

    // Withdrawals
    WITHDRAWALS_LIST: '/admin/withdrawals',
    WITHDRAWAL_APPROVE: '/admin/withdrawals/:id/approve',

    // Promo Codes
    PROMOS_LIST: '/admin/promo-codes',
    PROMO_ADD: '/admin/promo-codes',
    PROMO_UPDATE: '/admin/promo-codes/:id',
    PROMO_DELETE: '/admin/promo-codes/:id',
    PROMO_USAGE: '/admin/promo-codes/:id/usage',

    // Pricing
    PRICING_LIST: '/admin/pricing',
    PRICING_UPDATE: '/admin/pricing/:vehicleTypeId',

    // Notifications
    NOTIFICATIONS_SEND: '/admin/notifications/send',
    NOTIFICATIONS_HISTORY: '/admin/notifications/history',

    // Reports
    REPORTS: '/admin/reports/:reportType',

    // Emergency
    EMERGENCY_ALERTS: '/admin/emergency-alerts',
    EMERGENCY_RESOLVE: '/admin/emergency-alerts/:id/resolve',

    // Live Tracking
    LIVE_TRACKING: '/admin/live-tracking',

    // Ratings
    RATINGS_LIST: '/admin/ratings',
    RATING_FLAG: '/admin/ratings/:id/flag',

    // Support
    SUPPORT_TICKETS: '/admin/support/tickets',
    SUPPORT_TICKET_DETAILS: '/admin/support/tickets/:id',
    SUPPORT_TICKET_REPLY: '/admin/support/tickets/:id/reply',

    // Settings
    SETTINGS_GET: '/admin/settings',
    SETTINGS_UPDATE: '/admin/settings',

    // Regions
    REGIONS_LIST: '/admin/regions',
    REGION_ADD: '/admin/regions',
    REGION_UPDATE: '/admin/regions/:id',
    REGION_DELETE: '/admin/regions/:id',

    // Document Types
    DOCUMENT_TYPES_LIST: '/admin/document-types',
    DOCUMENT_TYPE_ADD: '/admin/document-types',
    DOCUMENT_TYPE_UPDATE: '/admin/document-types/:id',
    DOCUMENT_TYPE_DELETE: '/admin/document-types/:id',

    // Main Services
    MAIN_SERVICES_LIST: '/admin/main-services',
    MAIN_SERVICE_ADD: '/admin/main-services',
    MAIN_SERVICE_UPDATE: '/admin/main-services/:id',
    MAIN_SERVICE_DELETE: '/admin/main-services/:id',

    // Services
    SERVICES_LIST: '/admin/services',
    SERVICE_ADD: '/admin/services',
    SERVICE_UPDATE: '/admin/services/:id',
    SERVICE_DELETE: '/admin/services/:id',

    // Complaints
    COMPLAINTS_LIST: '/admin/complaints',
    COMPLAINT_DETAILS: '/admin/complaints/:id',
    COMPLAINT_REPLY: '/admin/complaints/:id/reply',
    COMPLAINT_STATUS: '/admin/complaints/:id/status',

    // Admin Users
    // ADMIN_USERS_LIST: '/admin/users',
    // ADMIN_USER_ADD: '/admin/users',
    // ADMIN_USER_UPDATE: '/admin/users/:id',

    ADMIN_USERS_LIST: '/admin/admin-users',
    ADMIN_USER_ADD: '/admin/admin-users',
    ADMIN_USER_UPDATE: '/admin/admin-users/:id',

    // Cancel Reasons
    CANCEL_REASONS_LIST: '/admin/cancel-reasons',
    CANCEL_REASON_ADD: '/admin/cancel-reasons',
    CANCEL_REASON_UPDATE: '/admin/cancel-reasons/:id',
    CANCEL_REASON_DELETE: '/admin/cancel-reasons/:id',

    // Rating Feedback Options
    RATING_FEEDBACK_OPTIONS_LIST: '/admin/rating-feedback-options',
    RATING_FEEDBACK_OPTION_ADD: '/admin/rating-feedback-options',
    RATING_FEEDBACK_OPTION_UPDATE: '/admin/rating-feedback-options/:id',
    RATING_FEEDBACK_OPTION_DELETE: '/admin/rating-feedback-options/:id',

    // FAQs
    FAQS_LIST: '/admin/faqs',
    FAQ_ADD: '/admin/faqs',
    FAQ_UPDATE: '/admin/faqs/:id',
    FAQ_DELETE: '/admin/faqs/:id',

    // Legal Pages
    LEGAL_PAGES_LIST: '/admin/legal-pages',
    LEGAL_PAGE_GET: '/admin/legal-pages/:pageType/:userType',
    LEGAL_PAGE_UPDATE: '/admin/legal-pages/:pageType/:userType',

    // Driver Recharge History
    DRIVER_RECHARGE_HISTORY: '/admin/recharge-history?driver_id=:id',
  },

  // Other Configuration
  TIMEOUT: 30000, // 30 seconds
  ITEMS_PER_PAGE: 20,

  // Upload Configuration
  UPLOADS_BASE_URL: `https://${SERVER_DOMAIN}/uploads`,

  // Theme Colors (Yellow & White)
  THEME: {
    PRIMARY: '#FFC107',
    SECONDARY: '#FFD54F',
    WHITE: '#FFFFFF',
    BLACK: '#212121',
  },

  // Google Maps API Key
  GOOGLE_MAPS_API_KEY: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || 'AIzaSyDrlzzBxjZiXN3XiwZqf0H3OCfYkDdqKCo',
};

export default config;
